import { LOCALE_LABELS } from '../constants';
export var detectLocale = function detectLocale(pathname) {
  var pathLocale = pathname.split('/')[1];

  if (pathLocale) {
    // Normalize the matched locale:
    // 1. Convert the first two characters (language code) to lowercase
    // 2. If a region code is present, keep the first character (either hyphen or underscore)
    // 3. Convert the remaining characters of the region code to uppercase
    var normalizedLocale = pathLocale.slice(0, 2).toLowerCase() + (pathLocale.length > 2 ? pathLocale.slice(2, 3) + pathLocale.slice(3).toUpperCase() : ''); // Check if the normalized locale exists in LOCALE_LABELS

    if (LOCALE_LABELS[normalizedLocale]) {
      return normalizedLocale;
    }
  }

  return undefined;
};